import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { HttpClient, HttpErrorResponse, HttpParams } from '@angular/common/http';
import { TypeAgent, ProcedureSetting } from '../settings/settings.model';
import { Role } from '../users/role.model';

@Injectable()
export class SettingsService {
  private readonly urlBase = '/api/';

  constructor(private httpClient: HttpClient) {}

  saveRole(role: Role) {
    return this.httpClient.post(this.urlBase + 'saveRole', role);
  }

  getModulesByRole(roleId: number): Observable<Array<number>> {
    return this.httpClient.get<Array<number>>(
      this.urlBase + 'getModulesByRole?roleId=' + roleId
    );
  }

  getModulesEditByRole(roleId: number): Observable<Array<number>> {
    return this.httpClient.get<Array<number>>(
      this.urlBase + 'getModulesEditByRole?roleId=' + roleId
    );
  }

  getModulesDeleteByRole(roleId: number): Observable<Array<number>> {
    return this.httpClient.get<Array<number>>(
      this.urlBase + 'getModulesDeleteByRole?roleId=' + roleId
    );
  }

  /**
   * Obtiene módulos con permisos por rol: Update, Upload, Reject y Verify
   * @param roleId Identificador del rol
   * @returns array de permisoss
   */
  getModulesAdditionalByRole(roleId: number): Observable<{
    success: boolean;
    message: string;
    data?: { [key: string]: number[] };
  }> {
    const params = new HttpParams().set('roleId', roleId.toString());
    return this.httpClient.get<any>(this.urlBase + 'getAdditionalModulesByRole', { params })
  }


  getDaysProcedures(): Observable<ProcedureSetting> {
    return this.httpClient.get<ProcedureSetting>(
      this.urlBase + 'getDaysProcedures'
    );
  }

  saveRoleSettings(data: any) {
    return this.httpClient.post<Array<number>>(
      this.urlBase + 'saveRoleSettings',
      data
    );
  }

  saveDaysProcedures(data: any) {
    return this.httpClient.post<Array<number>>(
      this.urlBase + 'saveDaysProcedures',
      data
    );
  }
}
